import "../../design/forgotPassword.css";
import {useState} from "react";
import api, {API_URL} from "../../api/API_SERVERS";
import Toast from "../../utils/components/Toast";
import Loading from "../../utils/components/Loading";

export default function ForgotPassword() {
    const [personID, setPersonID] = useState('');
    const [toast, setToast] = useState(null);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);

    const showToast = (message, type = "error") => {
        setToast({message, type});
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const res = await api.post(
                API_URL + '/api/teachers/forgot-password',
                { personId: personID }
            );

            setSuccess(true); // 👈 trigger skeleton screen
            showToast(res.data.message, 'success');
        } catch (e) {
            const message = e.response?.data?.message || "დაფიქსირდა შეცდომა";
            showToast(message);
        } finally {
            setLoading(false);
            setPersonID('');
        }
    };

    return (
        <div className="forgot-container">
            {loading && <Loading />}

            {toast && (
                <Toast
                    message={toast.message}
                    type={toast.type}
                    onClose={() => setToast(null)}
                />
            )}

            {success ? (
                <div className="forgot-success">
                    <div className="forgot-success-icon">✔️</div>
                    <h2>მოთხოვნა მიღებულია</h2>
                    <p>თუ პირადი ნომერი სწორია, თქვენ მიიღებთ შეტყობინებას ელ-ფოსტაზე.</p>
                    <button onClick={() => window.location.href = '/login'}>დაბრუნება</button>
                </div>
            ) : (
                <form className="forgot-form" onSubmit={handleSubmit}>
                    <h2 className="forgot-title">პაროლის აღდგენა</h2>

                    <div className="forgot-input-group">
                        <label className="forgot-input-label">ს/ნ</label>
                        <input
                            type="text"
                            className="forgot-input-field"
                            placeholder="მაგ: 01234567890"
                            value={personID}
                            onChange={(e) => setPersonID(e.target.value)}
                            required
                        />
                    </div>

                    <button
                        type="submit"
                        className="forgot-submit-button"
                        disabled={loading}
                    >
                        გაგრძელება
                    </button>
                </form>
            )}
        </div>
    );
}